var windowLoaded = false;
$(window).on("load", function() {
	windowLoaded = true;
});


//ready
jQuery(document).ready(function($){
//vertical nav
var contentSections = $('.svc-section'),

verticalNav = $('#success-vertical-nav'),
    navigationItems = $('#success-vertical-nav a'),
    mobileNavigationItems = $('#mobile-vertical-nav a');
function updateNavigation() {
	contentSections.each(function(){
			$this = $(this);

			if( $(window).height()/2 - $(window).scrollTop() >= $(window).scrollTop() ) {
					verticalNav.addClass('at-home');
			} else {
					verticalNav.removeClass('at-home');                
			}
	});
}
function updateMobileNavigation() {    
	contentSections.each(function(){
			$this = $(this);
			var activeSection = $('#mobile-vertical-nav a[href="#'+$this.data('section-name')+'"]');
			if ( ( $this.offset().top - $(window).height()/2 < $(window).scrollTop() ) && ( $this.offset().top + $this.height() - $(window).height()/2 > $(window).scrollTop() ) ) {           
					activeSection.addClass('active');            
			}else {
					activeSection.removeClass('active');
			}
	});
}
updateMobileNavigation();
updateNavigation();

function isOnScreen(elem) {
	// if the element doesn't exist, abort
	if( elem.length == 0 ) {
		return;
	}
	var $window = jQuery(window)
	var viewport_top = $window.scrollTop()
	var viewport_height = $window.height()
	var viewport_bottom = viewport_top + viewport_height
	var $elem = jQuery(elem)
	var top = $elem.offset().top
	var height = $elem.height()
	var bottom = top + height

	return (top >= viewport_top && top < viewport_bottom) ||
	(bottom > viewport_top && bottom <= viewport_bottom) ||
	(height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
}

	$(window).on('scroll', function(){
		updateNavigation();
		updateMobileNavigation();

		if($('.svc-wrapper').length) {
			if(isOnScreen('#judging')) {
				verticalNav.addClass('hover-background');  
			} else if(isOnScreen('#faq')) {
				verticalNav.addClass('hover-background');  
			} else {
				verticalNav.removeClass('hover-background');  
			}
		}
});

$('#success-vertical-nav').on({
	mouseenter: function () {
			verticalNav.addClass('hover-background');  
	},
	mouseleave: function () {
			verticalNav.removeClass('hover-background');
	}
});


	$('.mobile-vertical-trigger').on('click', function(){
    $('#mobile-vertical-nav').toggleClass('open');
});

	$('.faq-q').on('click', function() {
		$(this).siblings('.faq-a').toggleClass('a-active');
		$(this).children('.plus').toggleClass('hide');
		$(this).children('.minus').toggleClass('hide');
	});

	$('.open-popup-link-inline').magnificPopup({
		type:'inline',
		midClick: true // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
	});

	$('.svc-wrapper a[href*="#"]').on('click', function(e) {
		e.preventDefault()
		var t = $(this);
		console.log(t.attr('href'));
		$('html, body').animate(
			{
				scrollTop: $(t.attr('href')).offset().top - 32,
			},
			500,
			'linear'
		)
	});

	$('#success-vertical-nav a[href*="#"]').on('click', function(e) {
		e.preventDefault()
		var t = $(this);
		console.log(t.attr('href'));
		$('html, body').animate(
			{
				scrollTop: $(t.attr('href')).offset().top - 32,
			},
			500,
			'linear'
		)
	});

	$('#mobile-vertical-nav a[href*="#"]').on('click', function(e) {
		e.preventDefault()
		var t = $(this);
		console.log(t.attr('href'));
		$('html, body').animate(
			{
				scrollTop: $(t.attr('href')).offset().top - 32,
			},
			500,
			'linear'
		)
	});

//Load More News
function load_news(offset,perPage){
	var cats = "";
	if ($('input#press-releases').is(':checked')) cats = cats+"press-releases,";
	if ($('input#blogs').is(':checked')) cats = cats+"coalition-blog,";
	if ($('input#news-articles').is(':checked')) cats = cats+"news-articles,";

    $.ajax({
        type: "POST",
        dataType: "html",
        url: ajaxVars.ajax_url,
        data: {
				'cat': cats,
				'offset': offset,
				'perPage': perPage,
				'action': 'more_news_ajax'
			},
        success: function(data){
            var $data = $(data);
            if($data.length){
				if(perPage == -1) $(".news").html($data);
                else $(".news").append($data);
				$('#next-news-'+offset).remove();
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }

    });
    return false;
}

$('body').on('click', '.next-news-btn', function() {
	var offset = $(".next-news-btn").data('id');
    load_news(offset,8);
});

$('body').on('click', '.all-news-btn', function() {
	var offset = $(".all-news-btn").data('id');
    load_news(offset,-1);
});

$('.news-check').change(function(){
	var cats = "?";
	var atLeastOne = 0;
	if ($('input#blogs').is(':checked')){
		atLeastOne = 1;
		cats = cats+"coalition-blog";
	}
   	if ($('input#press-releases').is(':checked')){
		if(atLeastOne==1) cats = cats+"&";
		atLeastOne = 1;
		cats = cats+"press-releases";
	}
	if ($('input#news-articles').is(':checked')){
		if(atLeastOne==1) cats = cats+"&";
		cats = cats+"news-articles";
	}
	if(cats == "?" || cats =="?coalition-blog&press-releases&news-articles") cats = "";
	window.location.href = "/latest-news/"+cats;
});

//Load More Reports
function load_reports(offset,perPage){
	var cats = [];
	if ($('input#programs').is(':checked')) cats.push("programs");
	if ($('input#resources').is(':checked')) cats.push("resources");
	if ($('input#infographics').is(':checked')) cats.push("infographics");

    $.ajax({
        type: "POST",
        dataType: "html",
        url: ajaxVars.ajax_url,
        data: {
				'cat': 	JSON.stringify(cats),
				'perPage': perPage,
				'offset': offset,
				'action': 'more_reports_ajax'
			},
        success: function(data){
            var $data = $(data);
            if($data.length){
                if(perPage == -1) $(".news").html($data);
                else $(".news").append($data);
				$('#next-report-'+offset).remove();
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }

    });
    return false;
}

$('body').on('click', '.next-report-btn', function() {
	var offset = $(".next-report-btn").data('id');
    load_reports(offset,6);
});

$('body').on('click', '.all-report-btn', function() {
	var offset = $(".all-report-btn").data('id');
    load_reports(offset,-1);
});

$('.reports-check').change(function(){
	var cats = "?";
	var atLeastOne = 0;
	if ($('input#programs').is(':checked')){
		atLeastOne = 1;
		cats = cats+"programs";
	}
   	if ($('input#resources').is(':checked')){
		if(atLeastOne==1) cats = cats+"&";
		atLeastOne = 1;
		cats = cats+"resources";
	}
	if ($('input#infographics').is(':checked')){
		if(atLeastOne==1) cats = cats+"&";
		cats = cats+"infographics";
	}
	if(cats == "?" || cats =="?programs&resources&infographics") cats = "";
	window.location.href = "/reports-and-resources/"+cats;
});

//Load More Awards
function load_awards_recipients(offset){
    $.ajax({
        type: "POST",
        dataType: "html",
        url: ajaxVars.ajax_url,
        data: {
				'offset': offset,
				'action': 'more_awards_recipients_ajax'
			},
        success: function(data){
            var $data = $(data);
            if($data.length){
                $(".champions-area").append($data);
				$('#recipient-'+offset).remove();
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }

    });
    return false;
}

$('body').on('click', '.next-recipient-btn', function() {
	var offset = $(".next-recipient-btn").data('id');
    load_awards_recipients(offset);
});

function load_awards_events(offset){
    $.ajax({
        type: "POST",
        dataType: "html",
        url: ajaxVars.ajax_url,
        data: {
				'offset': offset,
				'action': 'more_awards_events_ajax'
			},
        success: function(data){
            var $data = $(data);
            if($data.length){
                $(".champions-area").append($data);
				$('#event-'+offset).remove();
            }
        },
        error : function(jqXHR, textStatus, errorThrown) {
            $loader.html(jqXHR + " :: " + textStatus + " :: " + errorThrown);
        }

    });
    return false;
}

$('body').on('click', '.next-event-btn', function() {
	var offset = $(".next-event-btn").data('id');
    load_awards_events(offset);
});

//Sliders and Popups
var slideWrapper = $(".hero-sections"),lazyCounter = 0;


// When the slide is changing
function playPauseVideo(slick, control){
  var currentSlide, slideType, startTime, player, video;

  currentSlide = slick.find(".slick-current");
  slideType = currentSlide.attr("class").split(" ")[1];
  startTime = currentSlide.data("video-start");
    video = currentSlide.find("video").get(0);
    if (video != null) {
      if (control === "play"){
        video.play();
      } else {
        video.pause();
      }
    }

}

// DOM Ready
$(function() {
  // Initialize
  slideWrapper.on("init", function(slick){
    slick = $(slick.currentTarget);
    setTimeout(function(){
      playPauseVideo(slick,"play");
    }, 1000);
  });
  slideWrapper.on("beforeChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"pause");
  });
  slideWrapper.on("afterChange", function(event, slick) {
    slick = $(slick.$slider);
    playPauseVideo(slick,"play");
  });

  //start the slider
  slideWrapper.slick({
    // fade:true,
    dots: true,
	  arrows: false,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
  	  autoplaySpeed: 7500,
	  fade: true,
	  cssEase: 'ease-in-out',
	  pauseOnHover:false
  });
});

	$('.tweets').slick({
	  dots: true,
	  arrows: false,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
  	  autoplaySpeed: 5000,
		responsive: [
    {
      breakpoint: 1024,
      settings: {
         dots: true,
	  arrows: false,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
  	  autoplaySpeed: 5000,
	  adaptiveHeight: true
      }
    }
  ]

	});

	$('.science-matters-slider').slick({
	  dots: true,
	  arrows: false,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
  	  autoplaySpeed: 5000
	});
	/*
	$('.members-slider').slick({
	  dots: true,
	  arrows: true,
	  infinite: true,
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  autoplay: true,
  	  autoplaySpeed: 5000
	});
	*/
	$("a[rel=popup]").magnificPopup({
		  type: 'inline',
		  fixedContentPos: true,
		  gallery: {
			  enabled: false
			}
	});

	$('.gallery').magnificPopup({
          delegate: 'a',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
          }
        });

//AOS
	AOS.init();

//vars
	var html = $('html');
	var header = $('header');
	var footer = $('footer');
	var overview = $('#overview .container');
	var delay_default = 300;
	var mediaQuery_mobile = window.matchMedia("(max-width: 1023px)");
	var mediaQuery_tablet = window.matchMedia("(max-width: 1024px)");
		//if(mediaQuery_mobile.matches)

//Boxes
	function resizeNewsTitles(){
		var maxHeight = 0;

		$(".news-title-small").each(function(){
		   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
		});

		$(".news-title-small").height(maxHeight);
	}

//Governance
	$('.year').click(function(e) {
		var year = $(this).data('id');
		e.preventDefault();
		$('.year').removeClass('active');
		$('.director-year').removeClass('active');
		$(this).addClass('active');
		$('#year-'+year).addClass('active');
	});

//SVG to inline
	inlineSVG.init({
		svgSelector: 'img.svg',
		initClass: 'js-inlinesvg',
	}, function () {
		console.log('All SVGs inlined');
	});


//smooth scroll to
	function smoothScrollTo(target) {
	    $('body, html').stop().animate({
	    	'scrollTop': target.offset().top - header.outerHeight()
	    }, delay_default*3, 'swing');
	}


//scroll to top
    $(window).scroll(function() {
   		if ($(this).scrollTop() >= ($(window).height() - header.outerHeight()) / 2) {
	        $('#return-to-top').show();
	    } else {
	        $('#return-to-top').hide();
	    }
	});

	$('#return-to-top').click(function(e) {
		e.preventDefault();
		smoothScrollTo(html);
	});

	$('.hero-button').on('click',function (e) {
	    e.preventDefault();
	    var target = $(this).data('id');
		target = $("#"+target);
	    smoothScrollTo(target);
	});

	// $('.scroll-down').on('click',function (e) {
	//     e.preventDefault();
	//     var target = $(this).data('id');
	// 	target = $("#"+target);
	//     smoothScrollTo(target);
	// });

	$('.btn-alt').on('click',function (e) {
	    e.preventDefault();
	    var target = $(this).data('id');
		target = $("#"+target);
	    smoothScrollTo(target);
	});

	$('.top-button').on('click',function (e) {
	    e.preventDefault();
	    var target = $(this).data('id');
		target = $("#"+target);
	    smoothScrollTo(target);
	});

//Sticky Nav
	var winh = $(window).height();
    winh = winh - $('header').outerHeight() + 3;
    if($(window).width() > 1024) {
		if($(window).scrollTop() >= winh/2) {
	        $('header').addClass('sticky');
		}
	}

    $(window).scroll(function() {
    	if($(window).width() > 1024) {
	        if($(this).scrollTop() >= winh/2) {
	            $('header').addClass('sticky');
	        } else {
	            $('header').removeClass('sticky');
	        }
    	}
    });


//Mobile Nav
	var $win = $(window);
	var $doc = $(document);
	var winH = $win.height();
	var winO = $win.scrollTop();
	var $sections;
	var $navLinks;
	var $DOMscroll;
	$DOMscroll 	= $('html, body');

	$('.mobile-toggle').on('click', function(e) {
        e.preventDefault();
        var slideoutMenu = $('.mobile-nav');slideoutMenuWidth = $('.mobile-nav').outerWidth();

        slideoutMenu.toggleClass("open");

        if (slideoutMenu.hasClass("open")) {
            slideoutMenu.animate({
                right: "0px"
            }).show();
        } else {
            slideoutMenu.animate({
                right: -slideoutMenuWidth,
            }, {
                duration: 250,
                complete: function() {
                    slideoutMenu.hide();
                }
            });
        }

        e.preventDefault();
    });

	$(".navbar-toggle").on("click", function (e) {
        var slideoutMenu = $('.mobile-nav');

        slideoutMenu.addClass("open");
		setTimeout(
		  function()
		  {
			lockScroll();
		  }, 450);

        e.preventDefault();
	 });

	$(".initiative").on("click", function (e) {
		var slideoutId = $(this).data('id');
        var slideout = $('#slideout-'+slideoutId);

        slideout.addClass("open");
		setTimeout(
		  function()
		  {
			lockScroll();
		  }, 450);

        e.preventDefault();
	 });

	$(".signup").on("click", function (e) {
        var slideout = $('#slideout-signup');

        slideout.addClass("open");
		setTimeout(
		  function()
		  {
			lockScroll();
		  }, 450);

        e.preventDefault();
	 });

	$('.close-nav').click(function() {
        var slideoutMenu = $('.mobile-nav');
        slideoutMenu.removeClass("open");
		unlockScrollNav();
    });

	$('.mobile-nav').on('click', function(e) {
		var slideout = $('.mobile-nav');
        slideout.removeClass("open");
		unlockScrollNav();
	}).on('click', 'div:not(.close-nav)', function(e) {
		e.stopPropagation();
	});

	$('.close-slideout').click(function() {
        var slideout = $('.slideout');
        slideout.removeClass("open");
		unlockScroll();
    });

	$('.slideout').on('click', function(e) {
		var slideout = $('.slideout');
        slideout.removeClass("open");
		unlockScroll();
	}).on('click', 'div:not(.close-slideout)', function(e) {
		e.stopPropagation();
	});

//Scroll Lock
	function lockScroll(){
		$html = $('html');
		$body = $('body');
		var initWidth = $body.outerWidth();
		var initHeight = $body.outerHeight();

		var scrollPosition = [
			self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
			self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
		];
		$html.data('scroll-position', scrollPosition);
		$html.data('previous-overflow', $html.css('overflow'));
		$html.css('overflow', 'hidden');
		window.scrollTo(scrollPosition[0], scrollPosition[1]);

		var marginR = $body.outerWidth()-initWidth;
		var marginB = $body.outerHeight()-initHeight;
		$body.css({'margin-right': marginR,'margin-bottom': marginB});
		$('.nav-header').css({'margin-right': "-"+marginR});
	}

	function unlockScroll(){
		$html = $('html');
		$body = $('body');
		$html.css('overflow', $html.data('previous-overflow'));
		var scrollPosition = $html.data('scroll-position');
		if(scrollPosition != undefined && scrollPosition != null) window.scrollTo(scrollPosition[0], scrollPosition[1]);

		$body.css({'margin-right': 0, 'margin-bottom': 0});
		$('.nav-header').css({'margin-right': 0});
	}

	function unlockScrollNav(){
		$html = $('html');
		$body = $('body');
		$html.css('overflow','auto');
		var scrollPosition = $html.data('scroll-position');
		window.scrollTo(scrollPosition[0], scrollPosition[1]);

		$body.css({'margin-right': 0, 'margin-bottom': 0});
		$('.nav-header').css({'margin-right': 0});
	}

//onScroll
	function onDocumentScroll() {
	}

    $(document).scroll(function() {
		onDocumentScroll();
	});


//documentReady
	console.log('Document Ready');


//onLoad
	resizeNewsTitles();

//onResize
	function onWindowResize() {
		resizeNewsTitles();
	}
	$(window).on('resize', function () {
		onWindowResize();
	});

	//women of wstem
	$(".story-block-bg").on("click", function (e) {
		if($('.slideout-pop-opened').length == 0) {
			var slideout = $('#' + $(this).data('id'));

		setTimeout(function(){ 
			slideout.addClass("slideout-pop-opened");
		}, 250);
	 	}
	});

	$(".close-slideout-pop").on("click", function (e) {
		$('.slideout-pop-opened').removeClass('slideout-pop-opened')
	});


	$(window).click(function() {
		if($('.slideout-pop-opened').length) {
			$('.slideout-pop-opened').removeClass('slideout-pop-opened');
		}

		});
		
		$('.slideout-pop-opened').click(function(event){
			event.stopPropagation();
		});

	//TSC In Action Scripts
	$('.load-more-gallery').on('click', function () {
		var gallery = $(this).data('id');
		$('.'+gallery).fadeIn();
		$('.'+gallery+' .nvisible-img').addClass('visible-img');
		$(this).hide();
	});
	$('.champions-gallery').magnificPopup({
          delegate: 'a.visible-img',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
              return '<div class="photo-text"><div class="caption">'+item.el.attr('data-caption')+'</div></div>';
            }
          }
        });
	$('.headliners-gallery').magnificPopup({
          delegate: 'a.visible-img',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
              return '<div class="photo-text"><div class="caption">'+item.el.attr('data-caption')+'</div></div>';
            }
          }
        });
	$('.events-gallery').magnificPopup({
          delegate: 'a.visible-img',
          type: 'image',
          tLoading: 'Loading image #%curr%...',
          mainClass: 'mfp-img-mobile',
          gallery: {
            enabled: true,
            navigateByImgClick: true,
            preload: [0,1] // Will preload 0 - before current, and 1 after the current image
          },
          image: {
            tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
            titleSrc: function(item) {
              return '<div class="photo-text"><div class="caption">'+item.el.attr('data-caption')+'</div></div>';
            }
          }
        });

	$('#vmap-sie').vectorMap({
		map: 'usa_en',
		backgroundColor: null,
		color: '#75D5FD',
		borderColor: '#022A45',
		borderOpacity: 1,
		//borderWidth: 1,
		enableZoom: false,
		showTooltip: true,
		selectedColor: '#FFFFFF',
		hoverColor: '#FFFFFF',
		multiSelectRegion: false,
		selectedRegions: null,
		onRegionClick: function(event, code, region){
			console.log('here1');
			$('.loader-wrapper').addClass('show');
					$('#vmap-sie-state-selection').val(code.toUpperCase());

					$('.state-info').hide();

					$('.state-'+code.toUpperCase()).show();

					$('.map-draw').addClass('open');
					smoothScrollTo($('.map-draw'));

		}
	});

	$("body").on("change", "#vmap-sie-state-selection", function(){
		if($(this).val()) {
			$('#jqvmap1_'+$(this).val().toLowerCase()).trigger('click');
			if($(window).width() <= 1024) {
				//$('html').addClass('prevent-scroll');
			}
			//$('#vmap').vectorMap('select', $(this).val());
		} else {
			if($('.map-draw').hasClass('open')) {
				$('.map-draw').removeClass('open');
				if($(window).width() <= 1024) {
				   // $('html').removeClass('prevent-scroll');
				} else {
					TweenMax.to($('.vmap-container'), .5, {left: '50%'});        
				}
			}
		}
	});


});

(function($){
	$(window).on("load",function(){
		$(".content-slide").mCustomScrollbar();
	});
})(jQuery);

(function($){
	$(window).on("load",function(){
		$(".vote-button").click(function(){
			var video_id = $(this).data("video-id");
			var ip =$(this).data("ip");
			$.post("https://www.sciencecoalition.org/wp-admin/admin-ajax.php",{
				action:"video_challenge_voting",
				video_id:video_id,
				ip:ip
			},function(e){},"json"),
			$(".vote-button").hide(),
			$(".vote-prompt").html("Thank you for voting for People's choice!"),
			Swal.fire("Thank you for voting for People's choice!")
		});
	});
})(jQuery);